export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_05.79e90d05.png";